import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ResetEnginePosition, SetEngineChapter, ClearGraph, ResetEngineInteractions } from '../engine/state/engine.actions';
import { StoryState } from '../story/state/story.state';
import { SelectBookmarkSuccess } from '../bookmarks/state/bookmarks.actions';
import { ResetStoryChapters } from '../story/state/chapters/story.chapters.actions';
import { ResetLabels } from '../story/state/labels/story.labels.actions';
import { ResetStory } from '../story/state/story.actions';
import { StoryService } from '../story/story.service';

@Injectable({
  providedIn: 'root'
})
export class CleanupService {

  constructor(
    private store: Store,
    private storyService: StoryService
  ) { }

  // Sets the engine and store back to completely unloaded story state
  resetScene() {
    // Hide the engine
    this.store.dispatch(new ResetEnginePosition());

    // Unload scene from engine
    // const story = this.store.selectSnapshot(StoryState.getStory);
    // if (story) {
    //   this.storyService.unloadStory();
    // }

    // Unload current bookmark
    this.store.dispatch(new SelectBookmarkSuccess(null));

    // Remove all chapters
    this.store.dispatch(new ResetStoryChapters());
    this.store.dispatch(new SetEngineChapter(''));

    // Remove all labels
    this.store.dispatch(new ResetLabels());
    
    // Remove the scene graph
    this.store.dispatch(new ClearGraph());

    // Revert engine prepared state
    // this.store.dispatch(new SetInteractive(false));

    // Reset engine interactions
    this.store.dispatch(new ResetEngineInteractions());

    // Reset story
    this.store.dispatch(new ResetStory());
  }
}
